/**
 * Pilote l'ouverture de `LabelSheet`, rendu une fois dans App.svelte.
 * Même schéma que le snooze : un identifiant de fil, ou `null`.
 */

interface LabelSheetState {
  threadId: string | null;
}

export const labelSheetState = $state<LabelSheetState>({ threadId: null });

export function openLabelSheet(threadId: string): void {
  labelSheetState.threadId = threadId;
}

export function closeLabelSheet(): void {
  labelSheetState.threadId = null;
}
